import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid } from "@mui/material";
import { Table } from "antd";
import { useEffect, useState } from "react";
import { getConfiguredNewCompetitionsInPrintCertificates } from "../../functions/getData";
import LoadingBackdrop from "../general/LoadingBackdrop";
import NunitoText from "../general/NunitoText";

export default function ViewConfiguredNewCompetitionsForPrintCertificate({
  cancelApprove,
}) {
  const [configuredCompetitions, setConfiguredCompetitions] = useState([]);
  const [formattedData, setFormattedData] = useState([]);
  const [loadingConfiguredCompetitions, setLoadingConfiguredCompetitions] =
    useState(false);

  const getConfiguredCompetitions = async () => {
    const filterData = await getConfiguredNewCompetitionsInPrintCertificates();
    return filterData;
  };

  const formatData = (data) => {
    let formattedData = [];
    data?.map((el) => {
      let formattedObj = {};
      let nestedRows = [];

      formattedObj.competition_name = el?.competition_name || "-";
      formattedObj.mode = el?.mode || "-";
      formattedObj.round_type = el?.round_type || "-";
      // Format nested rows from templates array
      el?.templates?.map((template) => {
        let formattedNestedObj = {};
        formattedNestedObj.award = template?.award || "-";
        formattedNestedObj.file_name = template?.file_name || "-";
        // Concatenate roles array with "-"
        formattedNestedObj.roles = Array.isArray(template?.roles)
          ? template.roles.map((role) => role.name || role).join(" - ")
          : "-";
        formattedNestedObj.show_disclaimer = template?.show_disclaimer || "-";
        nestedRows?.push(formattedNestedObj);
      });

      formattedObj.nestedData = nestedRows;
      formattedData.push(formattedObj);
    });
    return formattedData;
  };

  useEffect(() => {
    const getData = async () => {
      setLoadingConfiguredCompetitions(true);
      const filterData = await getConfiguredCompetitions();

      setConfiguredCompetitions(filterData);
      const formatted = formatData(filterData);
      setFormattedData(formatted);
      setLoadingConfiguredCompetitions(false);
    };
    getData();
  }, []);

  // Suppress ResizeObserver error - common issue with Ant Design tables
  useEffect(() => {
    const resizeObserverError = (e) => {
      if (
        e.message ===
          "ResizeObserver loop completed with undelivered notifications." ||
        e.message === "ResizeObserver loop limit exceeded"
      ) {
        e.stopImmediatePropagation();
      }
    };
    window.addEventListener("error", resizeObserverError);
    return () => {
      window.removeEventListener("error", resizeObserverError);
    };
  }, []);

  const parentColumns = [
    {
      title: "Competition Name",
      dataIndex: "competition_name",
      key: "competition_name",
    },
    { title: "Round Type", dataIndex: "round_type", key: "round_type" },
    { title: "Mode", dataIndex: "mode", key: "mode" },
  ];

  const nestedColumns = [
    { title: "Award", dataIndex: "award", key: "award" },
    { title: "File Name", dataIndex: "file_name", key: "file_name" },
    { title: "Roles", dataIndex: "roles", key: "roles" },
    {
      title: "Show Disclaimer",
      dataIndex: "show_disclaimer",
      key: "show_disclaimer",
    },
  ];

  const expandedRowRender = (record) => (
    <Table
      columns={nestedColumns}
      dataSource={record?.nestedData}
      pagination={false}
      rowKey={(row, index) => index}
    />
  );

  if (loadingConfiguredCompetitions) {
    return <LoadingBackdrop loading={loadingConfiguredCompetitions} />;
  }

  return (
    <Box
      className="popUpModal"
      style={{
        width: 1100,
        minHeight: 600,
        padding: "0 20px",
        gap: "16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
      }}
    >
      <NunitoText
        value="CONFIGURED NEW COMPETITIONS"
        fontSize={30}
        fontWeight={600}
        color="#5E75C3"
        marginTop={30}
        marginBottom={20}
      />

      <Grid
        container
        justifyContent="flex-end"
        // style={{ marginBlock: "30px 20px" }}
      >
        <button
          onClick={() => cancelApprove()}
          style={{
            border: "none",
            background: "none",
            cursor: "pointer",
            position: "absolute",
            right: 30,
            top: 36,
          }}
        >
          <CloseIcon style={{ width: 30, height: 30 }} />
        </button>
      </Grid>

      <div
        style={{
          width: "100%",
          height: "500px",
          overflow: "auto",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        <Table
          rowKey={(row, index) => index}
          columns={parentColumns}
          dataSource={formattedData}
          expandable={{ expandedRowRender, defaultExpandedRowKeys: ["0"] }}
          pagination={false}
          scroll={{ x: "max-content" }}
        />
      </div>
    </Box>
  );
}
